import { Component, EventEmitter, Input, Output } from '@angular/core';

// Company-page step 4 (Pricing Plan) - see company-page.component.ts's mapping
// notes: this panel (company-page.html's old data-step="4", lines 314-727)
// is shown only when TypeOfCompany is Company/Host (not Client/BusinessUnit/
// Vendor) and hostCompanySelected != true.
//
// Like-for-like display port: this step has no form of its own (no
// step4FormSubmitted/form-state-change on the legacy controller for this
// panel) - it's a read-only summary of current/future/expired plan plus a
// plan-picker whose "choose"/"modify" click (choosePlan) and slider-nav
// clicks (onSlideClick) stay implemented on the root legacy controller,
// which still owns `plans`/`savedCurrentActivePlan`/etc. and the
// modifyPlan()/modifyPlanModal wiring - this component only renders what
// those fields already compute and forwards the two click actions back up.
@Component({
  selector: 'app-company-page-step-plan',
  templateUrl: './company-page-step-plan.component.html'
})
export class CompanyPageStepPlanComponent {

  @Input() companyManagement: any = {};
  @Input() isActivePlanExists: boolean;
  @Input() stepFourNextClicked: boolean;
  @Input() savedCurrentActivePlanName: string;
  @Input() savedCurrentActivePlan: any = {};
  @Input() plans: any[] = [];
  @Input() isFuturePlanExists: boolean;
  @Input() futurePlanName: string;
  @Input() futurePlan: any = {};
  @Input() savedFuturePlanPriority: number;
  @Input() savedCurrentActivePlanPriority: number;
  @Input() expiredPlan: any;
  @Input() expiredPlanName: string;
  // Computed on the root controller from
  // $rootScope.userDetails.roleScreenRef.role.name, since a downgraded
  // native component can't reach into $rootScope for this the way the
  // legacy template did.
  @Input() hidePlanActionButtonsForRole: boolean;

  @Output() slideClickCallback = new EventEmitter<'left' | 'right'>();
  @Output() choosePlanCallback = new EventEmitter<number>();

  onSlideClick(direction: 'left' | 'right') {
    this.slideClickCallback.emit(direction);
  }

  choosePlan(planIndex: number) {
    this.choosePlanCallback.emit(planIndex);
  }
}
